/*eslint-disable*/
import api from '../'

class GameExerciseApi {

    //GET: game
    static show(id) {
        return api.axios.get('/game-exercises/' + id)
            .then(response => response.data.gameExercise);
    }

}

export default GameExerciseApi;
